import { Localized } from "@fluent/react"
import { Box, Chip } from "@mui/material"
import { alpha } from "@mui/material/styles"

export type DotChipColor = "success" | "error" | "warning" | "info" | "primary" | "secondary" | "default"

type Props = {
    l10nId: string
    label?: string
    color: DotChipColor
}

export const DotColorChip = ({ l10nId, label, color }: Props) => {
    return (
        <Chip
            size="small"
            variant="outlined"
            color={color === "default" ? undefined : color}
            icon={
                <Box
                    sx={(theme) => ({
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        bgcolor: color === "default" ? theme.palette.grey[500] : theme.palette[color].main,
                        flexShrink: 0,
                    })}
                />
            }
            label={
                <Localized id={l10nId}>
                    {label ?? l10nId}
                </Localized>
            }
            sx={(theme) => ({
                minWidth: 64,
                justifyContent: "center",
                bgcolor: alpha(
                    color === "default" ? theme.palette.grey[500] : theme.palette[color].main,
                    theme.palette.mode === "dark" ? 0.16 : 0.1
                ),
                borderColor: alpha(color === "default" ? theme.palette.grey[500] : theme.palette[color].main, 0.5),
                color: theme.palette.text.primary,
                fontWeight: 800,
                borderRadius: 1,
                height: 24,
                "& .MuiChip-label": { px: 1, py: 0.25, fontSize: "0.75rem", lineHeight: 1.6 },
                "& .MuiChip-icon": { mr: 0.5, ml: 0.5 },
            })}
        />
    )
}
